<template>
  <div class="background_concept">
    <div class="concept_index_text">
      <p style="font-size: 24px" class="animate__fadeInUp animate__animated">Value</p>
      <p style="font-size: 36px;margin-bottom: 0" class="animate__fadeInUp animate__animated animate__delay-1s">SIG endeavors to find companies with</p>
      <p style="font-size: 36px;" class="animate__fadeInUp animate__animated animate__delay-1s">unique value propositions.</p>
      <p style="font-size: 14px;margin-bottom: 0" class="animate__fadeInUp animate__animated animate__delay-2s">We believe that a truly great business starts with a distinctive
        business idea and stands out for its core values and beliefs.</p>
      <p style="font-size: 14px;margin-bottom: 0" class="animate__fadeInUp animate__animated animate__delay-2s"> We never stop looking for the companies that genuinely solve problems
        and may change the world in the future. </p>
      <p style="font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">When we find such a company, we stay in it for the long-run.</p>
      <div class="index_down animate__fadeInUp animate__animated animate__delay-3s">
        <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>


<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Concept_index',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 90 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>


<style scoped>
.background_concept {
  background-image: url("../../../assets/background/concept_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
}

.concept_index_text {
  padding-top: 28.4vh;
  text-align: left;
  margin-left: 12vw;
}

.index_down {
  padding-top: 2vh;
}
</style>